import client from './client'

export const authApi = {
  login: (token) => client.post('/auth/login', { token }),
  requestEmailLogin: (email) => client.post('/auth/request-email-login', { email }),
  emailLogin: (token) => client.post('/auth/email-login', { token }),
  logout: () => client.post('/auth/logout'),
  me: () => client.get('/auth/me'),
  quickLogins: () => client.get('/auth/quick-logins'),
  impersonate: (userId) => client.post('/auth/impersonate', { userId }),
  stopImpersonating: () => client.delete('/auth/impersonate')
}
